export default () => {
    // pause video on modal close
    $('[data-toggle="modal"]').on('click', function(){
        // get link's modal target
        var modalTarget = $(this).data('target');

        // if modal has an iframe
        if ( !$(modalTarget).find('iframe').length == 0 ) {

            // get iframe and src
            var modalIframe = $(modalTarget).find('iframe');
            var modalIframeSrc = $(modalIframe).attr('src');

            // set src attribute on close to ensure video stops playing
            $(modalTarget).on('hidden.bs.modal', () => {
                $(modalIframe).attr('src', modalIframeSrc);
            });

            // set src attribute on open
            $(modalTarget).on('show.bs.modal', () => {
                $(modalIframe).attr('src', modalIframeSrc);
            });
        }
    });
}